import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9d9bdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-title" }, "📦 Batch Processor", -1 /* HOISTED */))
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "nge-bp-flash"
}
const _hoisted_4 = { class: "nge-bp-create" }
const _hoisted_5 = ["onKeydown"]
const _hoisted_6 = {
  key: 0,
  class: "nge-bp-progress"
}
const _hoisted_7 = { class: "nge-bp-progress-label" }
const _hoisted_8 = { class: "nge-bp-progress-bar" }
const _hoisted_9 = {
  key: 1,
  class: "nge-bp-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "nge-bp-dataset-name" }
const _hoisted_12 = {
  key: 0,
  class: "nge-bp-dataset-tag nge-bp-dataset-tag--current"
}
const _hoisted_13 = {
  key: 1,
  class: "nge-bp-dataset-tag nge-bp-dataset-tag--other"
}
const _hoisted_14 = { class: "nge-bp-dataset-count" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "nge-bp-group-chevron" }
const _hoisted_17 = { class: "nge-bp-group-name" }
const _hoisted_18 = { class: "nge-bp-group-count" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-bp-group-spacer" }, null, -1 /* HOISTED */))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "nge-bp-group-body"
}
const _hoisted_22 = { class: "nge-bp-rename" }
const _hoisted_23 = ["value", "onChange"]
const _hoisted_24 = {
  key: 0,
  class: "nge-bp-chips"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "nge-bp-empty-segs"
}
const _hoisted_27 = { class: "nge-bp-add-row" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onUpdate:modelValue", "onKeydown"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "nge-bp-actions" }
const _hoisted_32 = ["onClick", "disabled"]
const _hoisted_33 = ["onClick", "disabled"]
const _hoisted_34 = ["onClick", "disabled"]
const _hoisted_35 = ["onClick", "disabled"]
const _hoisted_36 = ["onClick", "disabled"]
const _hoisted_37 = {
  key: 2,
  class: "nge-bp-sub"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-sub-label" }, "Pick color:", -1 /* HOISTED */))
const _hoisted_39 = { class: "nge-bp-swatches" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onChange"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 3,
  class: "nge-bp-sub"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-sub-label" }, "Cell type:", -1 /* HOISTED */))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select type...", -1 /* HOISTED */))
const _hoisted_46 = ["value"]
const _hoisted_47 = ["onClick", "disabled"]
const _hoisted_48 = {
  key: 4,
  class: "nge-bp-confirm"
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "nge-bp-confirm-btns" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 5,
  class: "nge-bp-guide"
}
const _hoisted_53 = {
  key: 0,
  class: "nge-bp-guide-intro"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-guide-title" }, "Place crosshairs in each cell", -1 /* HOISTED */))
const _hoisted_55 = { class: "nge-bp-guide-text" }
const _hoisted_56 = { class: "nge-bp-guide-actions" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "nge-bp-guide-walk" }
const _hoisted_60 = { class: "nge-bp-guide-stepper" }
const _hoisted_61 = { class: "nge-bp-guide-segid" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
], -1 /* HOISTED */))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { class: "nge-bp-guide-status" }
const _hoisted_66 = {
  key: 0,
  class: "nge-bp-guide-saved"
}
const _hoisted_67 = {
  key: 1,
  class: "nge-bp-guide-skipped"
}
const _hoisted_68 = {
  key: 2,
  class: "nge-bp-guide-pending"
}
const _hoisted_69 = { class: "nge-bp-guide-solo" }
const _hoisted_70 = ["checked", "onChange"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hide other cells", -1 /* HOISTED */))
const _hoisted_72 = { class: "nge-bp-guide-actions" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { class: "nge-bp-guide-nav" }
const _hoisted_77 = ["onClick", "disabled"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "nge-bp-guide-review" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-guide-title" }, "Ready to submit", -1 /* HOISTED */))
const _hoisted_81 = { class: "nge-bp-guide-summary" }
const _hoisted_82 = { class: "nge-bp-guide-list" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { class: "nge-bp-guide-item-pip" }
const _hoisted_85 = { class: "nge-bp-guide-item-id" }
const _hoisted_86 = ["onClick"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
], -1 /* HOISTED */))
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { class: "nge-bp-guide-actions" }
const _hoisted_90 = ["onClick", "disabled"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-empty" }, " No groups yet. Create one above to batch-process segments. ", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "nge-bp",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "nge-bp-panel",
          style: _normalizeStyle($setup.panelStyle)
        }, [
          _createCommentVNode(" Top bar "),
          _createElementVNode("div", {
            class: _normalizeClass(["nge-bp-topbar", { 'nge-bp-dragging': $setup.isDragging }]),
            onMousedown: $setup.startDrag
          }, [
            _hoisted_1,
            _createElementVNode("button", {
              class: "nge-bp-preview",
              onClick: _withModifiers($setup.previewBatchCelebration, ["stop"]),
              title: "Preview batch celebration"
            }, "🎉", 8 /* PROPS */, _hoisted_2),
            _createElementVNode("button", {
              class: "nge-bp-close",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
            }, "×")
          ], 34 /* CLASS, HYDRATE_EVENTS */),
          _createCommentVNode(" Flash message "),
          _createVNode(_Transition, { name: "nge-bp-flash" }, {
            default: _withCtx(() => [
              ($setup.flashMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.flashMessage), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" Create group "),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.newGroupName) = $event)),
              placeholder: "Group name...",
              class: "nge-bp-input",
              onKeydown: [
                _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                _withKeys(_withModifiers($setup.createGroup, ["prevent"]), ["enter"])
              ],
              onKeyup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
              onKeypress: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5), [
              [_vModelText, $setup.newGroupName]
            ]),
            _createElementVNode("button", {
              class: "nge-bp-btn nge-bp-btn--create",
              onClick: $setup.createGroup
            }, "+ Group")
          ]),
          _createCommentVNode(" Progress bar "),
          ($setup.batchProgress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.batchProgress.action === 'complete' ? 'Completing' : 'Annotating') + " " + _toDisplayString($setup.batchProgress.current) + "/" + _toDisplayString($setup.batchProgress.total) + "… ", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "nge-bp-progress-fill",
                    style: _normalizeStyle({ width: ($setup.batchProgress.current / $setup.batchProgress.total * 100) + '%' })
                  }, null, 4 /* STYLE */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Group list, sectioned by dataset "),
          ($setup.groups.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupsByDataset, (section) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: section.dataset,
                    class: _normalizeClass(["nge-bp-dataset-section", { 'nge-bp-dataset-section--cross': !section.isCurrent }])
                  }, [
                    _createElementVNode("div", {
                      class: "nge-bp-dataset-header",
                      onClick: $event => ($setup.toggleDatasetSection(section.dataset))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["nge-bp-dataset-arrow", { 'nge-bp-dataset-arrow--collapsed': $setup.collapsedDatasets.has(section.dataset) }])
                      }, "▾", 2 /* CLASS */),
                      _createElementVNode("span", _hoisted_11, [
                        _createTextVNode(_toDisplayString(section.label) + " ", 1 /* TEXT */),
                        (section.isCurrent)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "current"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, "other dataset"))
                      ]),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(section.groups.length), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_10),
                    (!$setup.collapsedDatasets.has(section.dataset))
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(section.groups, (group) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: group.id,
                            class: "nge-bp-group"
                          }, [
                            _createCommentVNode(" Group header "),
                            _createElementVNode("div", {
                              class: "nge-bp-group-header",
                              onClick: $event => ($setup.toggleExpand(group.id))
                            }, [
                              (group.color)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "nge-bp-group-color",
                                    style: _normalizeStyle({ background: group.color })
                                  }, null, 4 /* STYLE */))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("span", _hoisted_16, _toDisplayString($setup.expandedGroupId === group.id ? '▾' : '▸'), 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(group.name), 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(group.segmentIds.length), 1 /* TEXT */),
                              _hoisted_19,
                              _createElementVNode("button", {
                                class: "nge-bp-group-del",
                                onClick: _withModifiers($event => ($setup.deleteGroup(group.id)), ["stop"]),
                                title: "Delete group"
                              }, "×", 8 /* PROPS */, _hoisted_20)
                            ], 8 /* PROPS */, _hoisted_15),
                            _createCommentVNode(" Expanded content "),
                            ($setup.expandedGroupId === group.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createCommentVNode(" Rename "),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("input", {
                                      value: group.name,
                                      onChange: $event => ($setup.renameGroup(group, $setup.inputValue($event))),
                                      class: "nge-bp-input nge-bp-input--sm",
                                      placeholder: "Rename...",
                                      onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                                      onKeyup: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                                      onKeypress: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_23)
                                  ]),
                                  _createCommentVNode(" Segment chips "),
                                  (group.segmentIds.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.segmentIds, (segId) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: segId,
                                            class: "nge-bp-chip"
                                          }, [
                                            _createTextVNode(_toDisplayString($setup.truncId(segId)) + " ", 1 /* TEXT */),
                                            _createElementVNode("button", {
                                              class: "nge-bp-chip-x",
                                              onClick: $event => ($setup.removeSegment(group, segId))
                                            }, "×", 8 /* PROPS */, _hoisted_25)
                                          ]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_26, "No segments — add some below")),
                                  _createCommentVNode(" Add segments "),
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("button", {
                                      class: "nge-bp-btn nge-bp-btn--add",
                                      onClick: $event => ($setup.addAllVisible(group))
                                    }, "+ All Visible", 8 /* PROPS */, _hoisted_28),
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": $event => (($setup.addSegInput[group.id]) = $event),
                                      placeholder: "Paste IDs...",
                                      class: "nge-bp-input nge-bp-input--sm nge-bp-input--flex",
                                      onKeydown: [
                                        _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                                        _withKeys(_withModifiers($event => ($setup.addById(group)), ["prevent"]), ["enter"])
                                      ],
                                      onKeyup: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                                      onKeypress: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_29), [
                                      [_vModelText, $setup.addSegInput[group.id]]
                                    ]),
                                    _createElementVNode("button", {
                                      class: "nge-bp-btn nge-bp-btn--add",
                                      onClick: $event => ($setup.addById(group))
                                    }, "Add", 8 /* PROPS */, _hoisted_30)
                                  ]),
                                  _createCommentVNode(" Action bar "),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--color",
                                      onClick: _withModifiers($event => ($setup.colorPickerGroupId = $setup.colorPickerGroupId === group.id ? null : group.id), ["stop"]),
                                      disabled: group.segmentIds.length === 0
                                    }, " 🎨 Recolor ", 8 /* PROPS */, _hoisted_32),
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--complete",
                                      onClick: _withModifiers($event => ($setup.startCompleteWizard(group)), ["stop"]),
                                      disabled: group.segmentIds.length === 0
                                    }, " ✓ Proofread ", 8 /* PROPS */, _hoisted_33),
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--annotate",
                                      onClick: _withModifiers($event => {$setup.annotateGroupId = $setup.annotateGroupId === group.id ? null : group.id; $setup.selectedCellType = ''}, ["stop"]),
                                      disabled: group.segmentIds.length === 0
                                    }, " 🏷 Annotate ", 8 /* PROPS */, _hoisted_34),
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--copy",
                                      onClick: $event => ($setup.batchCopy(group)),
                                      disabled: group.segmentIds.length === 0
                                    }, " 📋 Copy ", 8 /* PROPS */, _hoisted_35),
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--remove",
                                      onClick: _withModifiers($event => ($setup.confirmAction = { groupId: group.id, action: 'remove' }), ["stop"]),
                                      disabled: group.segmentIds.length === 0
                                    }, " 🗑 Remove ", 8 /* PROPS */, _hoisted_36)
                                  ]),
                                  _createCommentVNode(" Color picker sub-panel "),
                                  ($setup.colorPickerGroupId === group.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        _hoisted_38,
                                        _createElementVNode("div", _hoisted_39, [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['#FF6B6B','#FFA726','#FFD700','#66BB6A','#42A5F5','#CE93D8','#26C6DA','#EF5350','#FFFFFF'], (c) => {
                                            return _createElementVNode("button", {
                                              key: c,
                                              class: "nge-bp-swatch",
                                              style: _normalizeStyle({ background: c }),
                                              onClick: $event => ($setup.batchRecolor(group, c))
                                            }, null, 12 /* STYLE, PROPS */, _hoisted_40)
                                          }), 64 /* STABLE_FRAGMENT */))
                                        ]),
                                        _createElementVNode("input", {
                                          type: "color",
                                          class: "nge-bp-color-input",
                                          onChange: $event => ($setup.batchRecolor(group, $setup.inputValue($event)))
                                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_41),
                                        (group.color)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "nge-bp-btn nge-bp-btn--sm",
                                              onClick: $event => ($setup.resetGroupColors(group))
                                            }, "Reset Colors", 8 /* PROPS */, _hoisted_42))
                                          : _createCommentVNode("v-if", true)
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  _createCommentVNode(" Annotate sub-panel "),
                                  ($setup.annotateGroupId === group.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                        _hoisted_44,
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.selectedCellType) = $event)),
                                          class: "nge-bp-select",
                                          onKeydown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                                          onKeyup: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
                                          onKeypress: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
                                        }, [
                                          _hoisted_45,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.RETINAL_CELL_TYPES, (ct) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: ct,
                                              value: ct
                                            }, _toDisplayString(ct), 9 /* TEXT, PROPS */, _hoisted_46))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                          [_vModelSelect, $setup.selectedCellType]
                                        ]),
                                        _createElementVNode("button", {
                                          class: "nge-bp-btn nge-bp-btn--go",
                                          onClick: $event => ($setup.batchAnnotate(group)),
                                          disabled: !$setup.selectedCellType
                                        }, "Apply", 8 /* PROPS */, _hoisted_47)
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  _createCommentVNode(" Confirm dialog (used for 'remove' only — 'complete' uses the guided wizard) "),
                                  ($setup.confirmAction && $setup.confirmAction.groupId === group.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                        ($setup.confirmAction.action === 'remove')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_49, " Remove " + _toDisplayString(group.segmentIds.length) + " segments from viewer? ", 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_50, [
                                          _createElementVNode("button", {
                                            class: "nge-bp-btn nge-bp-btn--go",
                                            onClick: $event => ($setup.batchRemoveFromViewer(group))
                                          }, "Yes", 8 /* PROPS */, _hoisted_51),
                                          _createElementVNode("button", {
                                            class: "nge-bp-btn nge-bp-btn--sm",
                                            onClick: _cache[15] || (_cache[15] = $event => ($setup.confirmAction = null))
                                          }, "Cancel")
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  _createCommentVNode(" ── Guided \"Mark Complete\" wizard ── "),
                                  ($setup.guide && $setup.guide.groupId === group.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                        _createCommentVNode(" Stage 1: Intro "),
                                        ($setup.guide.stage === 'intro')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                              _hoisted_54,
                                              _createElementVNode("p", _hoisted_55, " To mark " + _toDisplayString(group.segmentIds.length) + " cells as proofread, you'll place crosshairs inside each one so CAVE can map points to the right segment. Each cell needs its own point. ", 1 /* TEXT */),
                                              _createElementVNode("div", _hoisted_56, [
                                                _createElementVNode("button", {
                                                  class: "nge-bp-btn nge-bp-btn--sm",
                                                  onClick: $event => ($setup.loadAllSegmentsIntoViewer(group))
                                                }, "Load all into viewer", 8 /* PROPS */, _hoisted_57),
                                                _createElementVNode("button", {
                                                  class: "nge-bp-btn nge-bp-btn--go",
                                                  onClick: $event => ($setup.startWalk(group))
                                                }, "Start →", 8 /* PROPS */, _hoisted_58),
                                                _createElementVNode("button", {
                                                  class: "nge-bp-btn nge-bp-btn--sm",
                                                  onClick: $setup.cancelCompleteWizard
                                                }, "Cancel")
                                              ])
                                            ]))
                                          : ($setup.guide.stage === 'walk')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createCommentVNode(" Stage 2: Walk "),
                                                _createElementVNode("div", _hoisted_59, [
                                                  _createElementVNode("div", _hoisted_60, [
                                                    _createTextVNode(" Cell " + _toDisplayString($setup.guide.index + 1) + " of " + _toDisplayString(group.segmentIds.length) + " · ", 1 /* TEXT */),
                                                    _createElementVNode("span", {
                                                      class: "nge-bp-guide-color",
                                                      style: _normalizeStyle({ background: $setup.getSegmentColor(group.segmentIds[$setup.guide.index]) })
                                                    }, null, 4 /* STYLE */),
                                                    _createElementVNode("span", _hoisted_61, _toDisplayString($setup.truncId(group.segmentIds[$setup.guide.index])), 1 /* TEXT */),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-guide-copy",
                                                      onClick: $event => ($setup.copySegId(group.segmentIds[$setup.guide.index])),
                                                      title: "Copy full ID",
                                                      "aria-label": "Copy segment ID"
                                                    }, _hoisted_64, 8 /* PROPS */, _hoisted_62)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_65, [
                                                    ($setup.segStatus(group.segmentIds[$setup.guide.index]) === 'saved')
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_66, "✓ Saved"))
                                                      : ($setup.segStatus(group.segmentIds[$setup.guide.index]) === 'skipped')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_67, "— Skipped"))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_68, "Place crosshairs in the cell"))
                                                  ]),
                                                  _createElementVNode("label", _hoisted_69, [
                                                    _createElementVNode("input", {
                                                      type: "checkbox",
                                                      checked: $setup.guide.solo,
                                                      onChange: $event => ($setup.toggleSolo(group))
                                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_70),
                                                    _hoisted_71
                                                  ]),
                                                  _createElementVNode("div", _hoisted_72, [
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $event => ($setup.jumpToCurrentSegment(group))
                                                    }, "Show in viewer", 8 /* PROPS */, _hoisted_73),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--go",
                                                      onClick: $event => ($setup.saveCurrentPoint(group))
                                                    }, "Save Point", 8 /* PROPS */, _hoisted_74),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $event => ($setup.skipCurrent(group))
                                                    }, "Skip", 8 /* PROPS */, _hoisted_75)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_76, [
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $event => ($setup.prevSegment(group)),
                                                      disabled: $setup.guide.index === 0
                                                    }, "◂ Prev", 8 /* PROPS */, _hoisted_77),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $event => ($setup.nextSegment(group))
                                                    }, _toDisplayString($setup.guide.index === group.segmentIds.length - 1 ? 'Review →' : 'Next ▸'), 9 /* TEXT, PROPS */, _hoisted_78),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $setup.cancelCompleteWizard
                                                    }, "Cancel")
                                                  ])
                                                ])
                                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                            : ($setup.guide.stage === 'review')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  _createCommentVNode(" Stage 3: Review "),
                                                  _createElementVNode("div", _hoisted_79, [
                                                    _hoisted_80,
                                                    _createElementVNode("div", _hoisted_81, _toDisplayString(Object.keys($setup.guide.points).length) + " ready · " + _toDisplayString($setup.guide.skipped.size) + " skipped · " + _toDisplayString(group.segmentIds.length - Object.keys($setup.guide.points).length - $setup.guide.skipped.size) + " pending ", 1 /* TEXT */),
                                                    _createElementVNode("div", _hoisted_82, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.segmentIds, (segId, i) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: segId,
                                                          class: _normalizeClass(["nge-bp-guide-item", `nge-bp-guide-item--${$setup.segStatus(segId)}`]),
                                                          onClick: $event => ($setup.gotoSegment(group, i))
                                                        }, [
                                                          _createElementVNode("span", _hoisted_84, _toDisplayString($setup.segStatus(segId) === 'saved' ? '✓' : $setup.segStatus(segId) === 'skipped' ? '—' : '?'), 1 /* TEXT */),
                                                          _createElementVNode("span", {
                                                            class: "nge-bp-guide-item-color",
                                                            style: _normalizeStyle({ background: $setup.getSegmentColor(segId) })
                                                          }, null, 4 /* STYLE */),
                                                          _createElementVNode("span", _hoisted_85, _toDisplayString($setup.truncId(segId)), 1 /* TEXT */),
                                                          _createElementVNode("button", {
                                                            class: "nge-bp-guide-copy",
                                                            onClick: _withModifiers($event => ($setup.copySegId(segId)), ["stop"]),
                                                            title: "Copy full ID",
                                                            "aria-label": "Copy segment ID"
                                                          }, _hoisted_88, 8 /* PROPS */, _hoisted_86)
                                                        ], 10 /* CLASS, PROPS */, _hoisted_83))
                                                      }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_89, [
                                                      _createElementVNode("button", {
                                                        class: "nge-bp-btn nge-bp-btn--sm",
                                                        onClick: _cache[16] || (_cache[16] = $event => ($setup.guide.stage = 'walk'))
                                                      }, "◂ Back to walk"),
                                                      _createElementVNode("button", {
                                                        class: "nge-bp-btn nge-bp-btn--go",
                                                        onClick: $event => ($setup.submitGuidedComplete(group)),
                                                        disabled: Object.keys($setup.guide.points).length === 0
                                                      }, " Submit (" + _toDisplayString(Object.keys($setup.guide.points).length) + ") ", 9 /* TEXT, PROPS */, _hoisted_90),
                                                      _createElementVNode("button", {
                                                        class: "nge-bp-btn nge-bp-btn--sm",
                                                        onClick: $setup.cancelCompleteWizard
                                                      }, "Cancel")
                                                    ])
                                                  ])
                                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                              : _createCommentVNode("v-if", true)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createCommentVNode(" Empty state "),
                _hoisted_91
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        ], 4 /* STYLE */)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}